export class DetailsInputModelAnswers {
    recommendationBookId: number
    userId:number
}